import { GetPostsOutDto, Post } from "../../../types/post";
export const GET_POSTS_TO_REORDER = "GET_POSTS_TO_REORDER";
export const UPDATE_GET_POSTS_TO_REORDER = "UPDATE_GET_POSTS_TO_REORDER";
export const GET_POSTS_TO_REORDER_SUCCESS = "GET_POSTS_TO_REORDER_SUCCESS";
export const GET_POSTS_TO_REORDER_ERROR = "GET_POSTS_TO_REORDER_ERROR";
export const RESET_GET_POSTS_TO_REORDER = "RESET_GET_POSTS_TO_REORDER";

export interface GetPostsToReorder {
  type: typeof GET_POSTS_TO_REORDER;
  payload: GetPostsOutDto;
}

export interface UpdategetPostsToReorder {
  type: typeof UPDATE_GET_POSTS_TO_REORDER;
  payload: Post[];
}

export interface GetPostsToReorderSuccess {
  type: typeof GET_POSTS_TO_REORDER_SUCCESS;
  payload: Post[];
}

export interface GetPostsToReorderError {
  type: typeof GET_POSTS_TO_REORDER_ERROR;
  payload: string | boolean;
}

export interface ResetgetPostsToReorder {
  type: typeof RESET_GET_POSTS_TO_REORDER;
  payload: null;
}

export interface State {
  data: Post[] | null;
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions =
  | GetPostsToReorder
  | GetPostsToReorderSuccess
  | GetPostsToReorderError
  | UpdategetPostsToReorder
  | ResetgetPostsToReorder;
